import { territoryColor } from "./atlas-color.js";
import workerSource from "community-worker-source";

export function installCommunityLayer(renderer,graph,semantic,onChange) {
  let groups=[],version=0,timer=null,killed=false,ready=false,error=null;

  const byNode=new Map();
  const url=URL.createObjectURL(new Blob([workerSource],{type:"text/javascript"})),worker=new Worker(url);URL.revokeObjectURL(url);
  worker.onmessage=({data})=>{
    if(killed||data.version!==version)return;
    if(data.error){error=data.error;return;}
    groups=data.groups.map(g=>({...g,color:territoryColor(g.color)}));byNode.clear();
    for(const g of groups)for(const id of g.members)byNode.set(id,g);
    ready=true;
    onChange();renderer.refresh();
  };
  worker.onerror=()=>{error="Community worker unavailable";};
  const update=()=>{version++;clearTimeout(timer);timer=setTimeout(()=>worker.postMessage({version,nodes:graph.nodes(),edges:graph.mapEdges((id,a,s,t)=>[s,t])}),600);};
  const events=["nodeAdded","nodeDropped","edgeAdded","edgeDropped","cleared","edgesCleared"];
  events.forEach(e=>graph.on(e,update));
  // Group navigation replaces overlapping GPU density halos.
  const kill=()=>{killed=true;clearTimeout(timer);events.forEach(e=>graph.off(e,update));worker.terminate();};
  renderer.on("kill",kill);
  return { groups(){return groups;}, get(id){return byNode.get(id);}, stats(){return {ready,error,communities:groups.length,meaningful:groups.filter(g=>g.members.length>=8).length,uploads:0};},kill };
}
